import {Component, EventEmitter, OnInit} from '@angular/core';
import {UntypedFormControl, Validators} from '@angular/forms';
import {MDBModalRef} from 'ng-uikit-pro-standard';
import {take} from 'rxjs/operators';
import {ChecklistsService} from '../../../../common/services/checklists.service';
import {Localization} from '../../../../common/enums/localization';
import {ChecklistNode} from '../../checklist/model/checklist-node';
import {TemplateChecklistNodeType} from "../../../../common/enums/enums";
import {IdAndLabel} from "../../../../common/model/id-and-label";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-change-checklist-type-modal',
  templateUrl: './change-checklist-type-modal.component.html',
  styleUrls: ['./change-checklist-type-modal.component.scss']
})
export class ChangeChecklistTypeModal implements OnInit {
  public readonly Localization = Localization;
  public isBusy = false;
  public node: ChecklistNode;

  public readonly checklistTypeField = new UntypedFormControl(null, [Validators.required]);
  public readonly checklistTypeOptions = Object.values(TemplateChecklistNodeType)
                                                            .map(type => (new IdAndLabel(type, this.translate.instant(`templateChecklistNodeType_${type}`))));

  private readonly updatedNode$ = new EventEmitter<ChecklistNode>();
  public readonly onNodeUpdated = this.updatedNode$.pipe(take(1)).toPromise();

  constructor(
      private readonly checklistsService: ChecklistsService,
      private readonly translate: TranslateService,
      private readonly self: MDBModalRef,
  ) { }


  public ngOnInit() {
    this.checklistTypeField.patchValue(this.node.type);
  }

  public close(){
    this.self.hide();
    this.updatedNode$.emit(this.node);
  }

  public async onSubmit() {
    const updatedNode = await this.updateChecklist();
    this.updatedNode$.emit(updatedNode);
    this.close();
  }

  private async updateChecklist() {
    const updatedNode = {
      ...this.node,
      type: this.checklistTypeField.value,
    } as ChecklistNode;
    this.isBusy = true;
    try {
      await this.checklistsService.updateNode(updatedNode, true).toPromise();
      return updatedNode;
    } finally {
      this.isBusy = false;
    }
  }

}
